<template>
    <transition name="fade">
        <div v-if="step == 1" class="container">
            <h1 class="title-logo">
                Дата доставки
                <router-link to="/basket" class="title-close">
                    <svg class="svg-icon-close svg-icon" width="20" height="20">
                        <use xlink:href="#close"></use>
                    </svg>
                </router-link>
            </h1>
            <p>Необходимо указать дату доставки</p>
            <form class="flex-form" action="/">
                <div class="bottom-section">
                    <div class="input-wrap air-datepicker-global-container">
                        <input class="datepicker js-datepicker-item"  type="text" id="delivery-date">
                    </div>
                    <button class="primary-btn lg-btn wide-btn" type="button" @click="next"><span>Далее</span></button>
                </div>
            </form>
        </div>
        <div v-else-if="step == 2" class="container">
            <h1 class="title-logo">
                Укажите место доставки
                <!--<router-link to="/basket" class="title-close">
                    <svg class="svg-icon-close svg-icon" width="20" height="20">
                        <use xlink:href="#close"></use>
                    </svg>
                </router-link>-->
            </h1>
            <!--
             <span v-if="address.length > 0">{{address}}</span>
             <span v-else>Уточняется</span>
            -->
            <form v-if="false"><input type="text" placeholder="Место доставки" v-model="address"></form>

            <div class="stock-map">
                <div class="stock-map__map-wrap" id="map"></div>
                <div class="stock-map__placemark"></div>
            </div>
            <div class="flex-bottom-section">
                <button @click="prev" class="neutral-btn lg-btn" type="button">
                    <svg class="svg-icon-arrow-left svg-icon" width="24" height="11">
                        <use xlink:href="#arrow-left"></use>
                    </svg>
                </button>
                <button class="primary-btn lg-btn wide-btn" @click="createOrder" type="button">Заказать</button>
            </div>
        </div>
        <div v-else>Перейти к заказу</div>


        <!--<div v-if="showAddress && false" class="container">
            <h1 class="title-logo">
                Место доставки
                <a @click="showAddress = false;" class="title-close">
                    <svg class="svg-icon-close svg-icon" width="20" height="20">
                        <use xlink:href="#close"></use>
                    </svg>
                </a>
            </h1>

             <span v-if="address.length > 0">{{address}}</span>
             <span v-else>Уточняется</span>

            <form><input type="text" placeholder="Место доставки" v-model="address"></form>

            <div class="stock-map">
                <div class="stock-map__map-wrap" id="map"></div>
                <div class="stock-map__placemark"></div>
            </div>
            <div class="bottom-section">
                <button class="primary-btn lg-btn wide-btn" @click="addAddress" type="button">Сохранить</button>
            </div>
        </div>
        <div v-else-if="false" class="container">
            <h1 class="title-logo">
                Укажите дату и место
                <router-link to="/basket" class="title-close">
                    <svg class="svg-icon-close svg-icon" width="20" height="20">
                        <use xlink:href="#close"></use>
                    </svg>
                </router-link>
            </h1>

            <form class="flex-form" action="/">
                <p>Дата доставки</p>
                <div class="input-wrap air-datepicker-global-container">

                    <input class="datepicker js-datepicker-item"  type="text" id="delivery-date-old">
                </div>
                <p>Место доставки</p>

                <div v-for="item in addressItems" class="data-input-wrap">
                    <div class="check-wrap ">
                        <input type="radio" :id="'place-' + item.id" name="place"  :value="item.id" v-model="selectAddressId">
                        <label :for="'place-' + item.id">
                            <span></span>
                            <span>{{item.label}}</span>
                        </label>
                    </div>
                    <div class="data-input-control">
                        <div class="data-input-control__btn" @click="showChangeAddress(item.id, item.label, item.lat, item.lon)">изменить</div>
                    </div>
                </div>

                <a @click="showAddAddress" class="white-btn data-input-add" href="javascript:;">Добавить место доставки</a>
                <div class="bottom-section">
                    <button class="primary-btn lg-btn wide-btn" type="button" @click="createOrder"><span>Заказать</span></button>
                </div>
            </form>
        </div>
        -->
    </transition>
</template>
<style scoped>
   .neutral-btn{
       margin-right: 10px;
       min-width: 60px;
    }
   .neutral-btn .svg-icon {
       margin-right: 0px;
   }
    .container {
        padding: 15px 20px 10px;
    }
   .title-close{
       right: 15px;
       position: absolute;
   }
   h1 + form {
       margin-top:0px;
   }
</style>
<script>

    let myMap = {};

    import IMask from 'imask';
    import AirDatepicker from 'air-datepicker'

    import {HTTP} from "../modules/http-common"

    export default {

        name: 'Order',

        props: ['id'],

        data: function(){
            return {
                address:'',
                addressDefault:'Моя дача',
                showAddress:false,
                initMap:false,
                defaultCenter:[55.753994, 37.622093],
                defaultZoom:10,
                zoom:0,
                center:[],
                myMap:{},
                timeOutId:false,
                selectAddressId:0,
                addressGeo:{
                    lat:0,
                    lon:0
                },
                addressItems:[],
                datePicker:false,
                changeAddressId: 0,

                step:1,
                deliveryDate:'',
            };
        },

        watch:{
            showAddress: function(){
                let vm = this;
                if(vm.showAddress) {
                    if(vm.datePicker)
                        vm.datePicker.destroy();
                    setTimeout(() => {
                        ymaps.ready(function () {
                            myMap = new ymaps.Map('map', {
                                center: vm.center,
                                zoom: vm.zoom,
                                controls: ['zoomControl']
                            }, {

                                searchControlProvider: 'yandex#map'
                            });
                            myMap.events.add('actionend', function (e) {
                                //clearTimeout(vm.timeOutId);
                                let geo = e.originalEvent.map.getCenter();
                                if(e.originalEvent.map._zoom >= 10){
                                    vm.addressGeo.lat = geo[0];
                                    vm.addressGeo.lon = geo[1];
                                    /*vm.timeOutId = setTimeout(function(){
                                        console.log("setTimeout 3");
                                        vm.getAddressByGeo(geo[0], geo[1]);
                                    }, 3000);*/
                                }
                            });
                        });
                    }, 200);
                }else{
                    myMap.destroy();
                    vm.createDatePicker();
                }
            }
        },

        computed: {
            user: function () {
                return this.$store.getters.getUser;
            },
        },

        created() {
            let vm = this;
            vm.center = vm.defaultCenter;
            vm.address = vm.addressDefault;
            vm.zoom = vm.defaultZoom;
            vm.deliveryDate = "";
            vm.changeAddressId = 0;
            this.$root.scrollable = false;
            this.$root.pageClass = "";

        },

        mounted:function () {
            this.getAddresses();
            this.createDatePicker();

        },

        components: {},

        methods: {
            "prev": function () {
                this.showAddress = false;
                this.step = this.step - 1;
            },

            "next": function () {
                switch (this.step) {
                    case 1:
                        this.showAddress = true;
                        this.deliveryDate = document.getElementById("delivery-date").value;
                    break;
                    default:
                        this.showAddress = false;
                }
                this.step = this.step + 1;
            },


            "currentDate": function(){
                const today = new Date();
                const yyyy = today.getFullYear();
                let mm = today.getMonth() + 1; // Months start at 0!
                let dd = today.getDate();

                if(dd < 10)
                    dd += "0" + dd;

                if(mm < 10)
                    mm += "0" + mm;

                return dd + '.' + mm + '.' + yyyy;
            },

            "createOrder": function(){
                let vm = this;

                let saveAddressPomice = new Promise((resolve, reject) => {
                    if(vm.changeAddressId > 0){
                        const params = JSON.stringify({id:vm.changeAddressId, label:vm.address,lat: vm.addressGeo.lat, lon:vm.addressGeo.lon});
                        HTTP.post(
                            "/user/changeAddress",
                            params
                        ).then(function (json) {
                            if ("id" in json.data) {
                                vm.addressItems.forEach(function(element, index){
                                    if(element.id == json.data.id){
                                        vm.addressItems[index].label = json.data.label;
                                        vm.addressItems[index].lat = json.data.lat;
                                        vm.addressItems[index].lon = json.data.lon;
                                    }
                                });
                                vm.selectAddressId = json.data.id;
                                resolve();
                            }else{
                                reject();
                            }

                        });
                    }else{
                        const params = JSON.stringify({label:vm.address,lat: vm.addressGeo.lat, lon:vm.addressGeo.lon});
                        HTTP.post(
                            "/user/saveAddress",
                            params
                        ).then(function (json) {
                            if ("id" in json.data) {
                                vm.addressItems.push({
                                    id:json.data.id,
                                    label:json.data.label,
                                });
                                vm.selectAddressId = json.data.id;
                                resolve();
                            }else{
                                reject();
                            }
                        });
                    }
                });

                saveAddressPomice.then(
                    function(){
                        HTTP.post(
                            "/order/create",
                            JSON.stringify({
                                date_delivery:vm.deliveryDate,
                                address:{
                                    id:parseInt(vm.selectAddressId),
                                },
                                basket_group_id:parseInt(vm.id)
                            })
                        ).then(function (json) {
                            if ("id" in json.data) {
                                vm.showAddress = false;
                                vm.$router.push('/order/' + json.data.id);
                            }else{
                                alert("Ошибка создания заказа, повторите позже.")
                            }
                        });
                    },
                    function(){
                        alert("Ошибка сохранения заказа.")
                    }
                );

            },

            "selectAddress":function(id, label, lat, lon){
                let vm = this;
                vm.center = [lat, lon];
                vm.address = label;
                vm.changeAddressId = id;

                vm.addressGeo.lat = vm.center[0];
                vm.addressGeo.lon = vm.center[1];

                vm.zoom = 16;
                //vm.showAddress = true;
            },

            "showAddAddress":function(){
                let vm = this;
               // vm.center = vm.defaultCenter;
               // vm.address = vm.addressDefault;
               // vm.zoom = vm.defaultZoom;
                //vm.changeAddressId = 0;
                vm.showAddress = true;
            },

            "createDatePicker": function(){
                let vm = this;
                setTimeout(function(){
                    vm.datePicker = new AirDatepicker(document.getElementById("delivery-date"), {
                        selectedDates: [new Date()],
                        isMobile: true,
                        autoClose: true,
                    }, 100);
                });

            },

            "getAddresses": function(){
                let vm = this;
                HTTP.get( "/user/getAddresses").then(function (json) {
                   if('items' in json.data){
                       vm.addressItems = json.data.items;
                       let lastAddress = vm.addressItems[vm.addressItems.length - 1];
                       vm.selectAddress(lastAddress.id, lastAddress.label, lastAddress.lat, lastAddress.lon);
                   }
                });
            },

            "addAddress": function(){
                let vm = this;
                if(vm.changeAddressId > 0){
                    const params = JSON.stringify({id:vm.changeAddressId, label:vm.address,lat: vm.addressGeo.lat, lon:vm.addressGeo.lon});
                    HTTP.post(
                        "/user/changeAddress",
                        params
                    ).then(function (json) {
                        if ("id" in json.data) {
                            vm.addressItems.forEach(function(element, index){
                                if(element.id == json.data.id){
                                    vm.addressItems[index].label = json.data.label;
                                    vm.addressItems[index].lat = json.data.lat;
                                    vm.addressItems[index].lon = json.data.lon;
                                }
                            });
                            vm.selectAddressId = json.data.id;
                        }
                        vm.showAddress = false;
                    });
                }else{
                    const params = JSON.stringify({label:vm.address,lat: vm.addressGeo.lat, lon:vm.addressGeo.lon});
                    HTTP.post(
                        "/user/saveAddress",
                        params
                    ).then(function (json) {
                        if ("id" in json.data) {
                            vm.addressItems.push({
                                id:json.data.id,
                                label:json.data.label,
                            });
                            vm.selectAddressId = json.data.id;
                        }
                        vm.showAddress = false;
                    });
                }
            },

            "getAddressByGeo": function(lat, lon){
                let vm = this;

                const params = JSON.stringify({lat: lat + "", lon:lon + ""});

                HTTP.post(
                    "/page/getAddressByGeo",
                    params
                ).then(function (json) {
                    if ('items' in json.data) {
                        let address = json.data.items[0];
                        if(parseFloat(address.lat).toFixed(4) == lat.toFixed(4) && parseFloat(address.lon).toFixed(4) == lon.toFixed(4)){
                            vm.address = address.value;
                        }else if(address){
                            vm.address = address.region_with_type;
                        }else{
                            vm.address = "Доставка по координатам";
                        }
                        //myMap.setCenter([address.lat, address.lon]);
                    }
                });

            }
        }
    }
</script>
